// extracted by mini-css-extract-plugin
export default {"wrapper":"lfqqaWmIL2oOdBrZ0rjD","deleteButton":"dMy9jQEbVpVFAsUECakK","deleteIcon":"uKbdsFDOMhxskW2UtPCt"};